export const ZONE_OPTIONS = [
    { value: "1", label: "Europa" },
    { value: "2", label: "México" },
    { value: "3", label: "Estados Unidos" },
];

export const ZONE_LABEL_MAP = [
    undefined,
    "Europa",
    "México",
    "Estados Unidos",
];

export const ZONE_LABEL_MAP_ZERO = [
    "Europa",
    "México",
    "Estados Unidos",
];
